import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignHorizontalCentre20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowAlignHorizontalCentre20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.75 1.75a.75.75 0 0 0-1.5 0V5.6L7.37 3.72a.75.75 0 0 0-1.06 1.06l3.18 3.182.53.53.531-.53 3.182-3.182a.75.75 0 1 0-1.06-1.06L10.75 5.643zM3 10a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 10m7.043 9a.75.75 0 0 1-.75-.75v-3.893L7.37 16.28a.75.75 0 0 1-1.06-1.06l3.181-3.182.53-.53.531.53 3.182 3.182a.75.75 0 1 1-1.06 1.06l-1.88-1.88v3.85a.75.75 0 0 1-.75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignHorizontalCentre20);
